import { LoadBoardTruckSearchUsers } from "../LoadBoardTruckSearchUsers";
import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadBoardTruckSearchSlideout extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelAssociatedUsers: Label;
    layoutAssociatedUsers: LoadBoardTruckSearchUsers;
    panelAssociatedUsers: Panel;
    sourceLoadBoardService: DataSource;
    sourcePnnTranscoreUser: DataSource;
    switchActive: Switch;
    textboxDescription: Textbox;
    textboxIntegrationId: Textbox;
    textboxPassword: Textbox;
    textboxUrl: Textbox;
    textboxUserId: Textbox;
}
